import { denormalisedEntities } from './data';

/**
 * Resolve a discovery wire listing to a denormalised listing with `images[]`
 * for ListingCard / map pins. Prefers Redux store; falls back to on-the-fly
 * denormalisation from entities already loaded for this search response.
 */
export const resolveDiscoveryListingForCard = (state, wireListing, getListingsByIdFn) => {
  if (!wireListing?.id) {
    return wireListing;
  }

  let fromStore = null;
  try {
    fromStore = getListingsByIdFn(state, [wireListing.id])[0] || null;
    if (fromStore?.images?.length) {
      return { ...wireListing, images: fromStore.images };
    }
  } catch (e) {
    // getListingsById may throw when relationships reference missing entities.
  }

  const { entities } = state.marketplaceData || {};
  const denorm = denormalisedEntities(
    entities,
    [{ id: wireListing.id, type: 'listing' }],
    false
  )[0];

  if (denorm?.images?.length) {
    return { ...wireListing, images: denorm.images };
  }

  return wireListing;
};
